import { defineComponent as u, openBlock as f, createBlock as c, mergeProps as s, unref as l, isRef as _, withCtx as r, createVNode as y, renderSlot as B, normalizeProps as C, guardReactiveProps as v } from "vue";
import { useVModel as $ } from "@vueuse/core";
import { _ as g } from "./HAccordionItem.vue_vue_type_script_setup_true_lang-f791cf24.mjs";
import { _ as O } from "./AccessibleComponent.vue_vue_type_script_setup_true_lang-b6d6fe78.mjs";
import { omit as V } from "lodash-es";
const S = /* @__PURE__ */ u({
  __name: "AccordionItem",
  props: {
    is: { default: "details" },
    open: { type: Boolean, default: void 0 },
    dimension: {},
    duration: {},
    transition: {},
    initiallyClosed: { type: Boolean, default: !0 },
    controlled: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(a, { emit: p }) {
    const d = p, o = a, i = $(o, "open", d, { passive: !0, defaultValue: !o.initiallyClosed }), m = (e) => o.is === "details" ? e.isTransitioning || e.isOpen : !1;
    return (e, n) => (f(), c(g, s(l(V)(o, ["is"]), {
      open: l(i),
      "onUpdate:open": n[0] || (n[0] = (t) => _(i) ? i.value = t : null),
      "initially-closed": e.initiallyClosed
    }), {
      default: r((t) => [
        y(O, s({
          is: e.is,
          "omit-role-for": ["li"],
          role: "listitem",
          open: m(t)
        }, e.$attrs), {
          default: r(() => [
            B(e.$slots, "default", C(v(t)))
          ]),
          _: 2
        }, 1040, ["is", "open"])
      ]),
      _: 3
    }, 16, ["open", "initially-closed"]));
  }
});
export {
  S as _
};
